import { RoleService, RoleServiceImplementation } from './Role'

export const roleService: RoleService = new RoleServiceImplementation()
